import enCatalogUrl from "../catalog/sany-en.csv";
import ruCatalogUrl from "../catalog/sany-ru.csv";

const EN_SHOP_ID = "67639189fd2e8b810942df8b";
const RU_SHOP_ID = "67643c55da6082114a6e3e8a";

const SHOP_CATALOGS = {
  [EN_SHOP_ID]: enCatalogUrl,
  [RU_SHOP_ID]: ruCatalogUrl,
};

const DISABLED_SUGGESTION_KEYS = new Set([
  "product id",
  "идентификатор продукта",
]);

const suggestionsCache = new Map();

export function normalizeSuggestionKey(value) {
  return `${value || ""}`.trim().toLowerCase();
}

function parseCsv(text) {
  const rows = [];
  let currentRow = [];
  let currentValue = "";
  let isInsideQuotes = false;

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (char === '"') {
      if (isInsideQuotes && nextChar === '"') {
        currentValue += '"';
        i += 1;
      } else {
        isInsideQuotes = !isInsideQuotes;
      }
      continue;
    }

    if (char === "," && !isInsideQuotes) {
      currentRow.push(currentValue);
      currentValue = "";
      continue;
    }

    if ((char === "\n" || char === "\r") && !isInsideQuotes) {
      if (char === "\r" && nextChar === "\n") {
        i += 1;
      }

      currentRow.push(currentValue);
      rows.push(currentRow);
      currentRow = [];
      currentValue = "";
      continue;
    }

    currentValue += char;
  }

  if (currentValue !== "" || currentRow.length > 0) {
    currentRow.push(currentValue);
    rows.push(currentRow);
  }

  return rows;
}

function buildSuggestionsMap(rows) {
  if (!rows.length) return new Map();

  const header = rows[0];
  const parameterPairs = header.reduce((result, title, index) => {
    const match = title.match(/^Характеристика (\d+) Ключ$/);

    if (!match) return result;

    const valueIndex = header.indexOf(`Характеристика ${match[1]} Значение`);

    if (valueIndex >= 0) {
      result.push([index, valueIndex]);
    }

    return result;
  }, []);

  const suggestionsMap = new Map();

  rows.slice(1).forEach((row) => {
    parameterPairs.forEach(([keyIndex, valueIndex]) => {
      const parameterKey = row[keyIndex]?.trim();
      const parameterValue = row[valueIndex]?.trim();

      if (!parameterKey || !parameterValue) return;

      const normalizedKey = normalizeSuggestionKey(parameterKey);

      if (!suggestionsMap.has(normalizedKey)) {
        suggestionsMap.set(normalizedKey, []);
      }

      const currentValues = suggestionsMap.get(normalizedKey);

      if (!currentValues.includes(parameterValue)) {
        currentValues.push(parameterValue);
      }
    });
  });

  return suggestionsMap;
}

function buildKeySuggestions(rows) {
  if (!rows.length) return [];

  const header = rows[0];
  const parameterKeyIndexes = header.reduce((result, title, index) => {
    if (/^Характеристика (\d+) Ключ$/.test(title)) {
      result.push(index);
    }

    return result;
  }, []);

  const uniqueKeys = new Map();

  rows.slice(1).forEach((row) => {
    parameterKeyIndexes.forEach((keyIndex) => {
      const parameterKey = row[keyIndex]?.trim();

      if (!parameterKey) return;

      const normalizedKey = normalizeSuggestionKey(parameterKey);

      if (DISABLED_SUGGESTION_KEYS.has(normalizedKey)) return;

      if (!uniqueKeys.has(normalizedKey)) {
        uniqueKeys.set(normalizedKey, parameterKey);
      }
    });
  });

  return Array.from(uniqueKeys.values()).sort((item1, item2) =>
    item1.localeCompare(item2)
  );
}

async function loadParameterSuggestionData(shopId) {
  const catalogUrl = SHOP_CATALOGS[shopId];

  if (!catalogUrl) {
    return {
      valueSuggestionsMap: new Map(),
      keySuggestions: [],
    };
  }

  if (!suggestionsCache.has(shopId)) {
    suggestionsCache.set(
      shopId,
      fetch(catalogUrl)
        .then((response) => response.text())
        .then((text) => {
          const rows = parseCsv(text);

          return {
            valueSuggestionsMap: buildSuggestionsMap(rows),
            keySuggestions: buildKeySuggestions(rows),
          };
        })
        .catch(() => ({
          valueSuggestionsMap: new Map(),
          keySuggestions: [],
        }))
    );
  }

  return suggestionsCache.get(shopId);
}

export async function loadParameterValueSuggestions(shopId) {
  const suggestionData = await loadParameterSuggestionData(shopId);

  return suggestionData.valueSuggestionsMap;
}

export async function loadParameterKeySuggestions(shopId) {
  const suggestionData = await loadParameterSuggestionData(shopId);

  return suggestionData.keySuggestions;
}

export function getParameterSuggestions(suggestionsMap, parameterName) {
  if (!parameterName) return [];

  const normalizedKey = normalizeSuggestionKey(parameterName);

  if (DISABLED_SUGGESTION_KEYS.has(normalizedKey)) {
    return [];
  }

  return suggestionsMap.get(normalizedKey) || [];
}
